import { render, staticRenderFns } from "./TournamentBrackets.vue?vue&type=template&id=52ea6d8c&scoped=true"
import script from "./TournamentBrackets.vue?vue&type=script&lang=js"
export * from "./TournamentBrackets.vue?vue&type=script&lang=js"
import style0 from "./TournamentBrackets.vue?vue&type=style&index=0&id=52ea6d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea6d8c",
  null
  
)

export default component.exports